export const ADD_NOTIFICATION = 'notifications/ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'notifications/REMOVE_NOTIFICATION';
export const CLEAR_ALL_NOTIFICATIONS = 'notifications/CLEAR_ALL_NOTIFICATIONS';